import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import Header from '../Header/Header';
import { MessageFilterTypes } from '../../Model';
import Conversations from '../Conversations/Conversations';
import { Prospect } from 'model/ProspectMessage';

interface ProspectMenuProps {
    selectedProspect: Prospect | undefined;
    setProspect: (prospect?: Prospect) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            height: '100%',
            overflow: 'hidden'
        }
    })
);

export const ProspectMenu: FunctionComponent<ProspectMenuProps> = props => {
    const classes = useStyles();
    const [searchText, setSearchText] = useState('');
    const [filter, setFilter] = useState<string>(MessageFilterTypes.NEWEST);

    return (
        <Box className={classes.root}>
            <Header
                onSearchText={setSearchText}
                onSelectFilter={setFilter}
            />
            <Conversations
                selectedProspect={props.selectedProspect}
                setProspect={props.setProspect}
                searchText={searchText}
                filter={filter}
            />
        </Box>
    );
};

export default ProspectMenu;
